export const ESTADOS_MATRICULA = [
  { value: "activa", label: "Activa" },
  { value: "reservada", label: "Reservada" },
  { value: "suspendida", label: "Suspendida" },
  { value: "finalizada", label: "Finalizada" },
  { value: "anulada", label: "Anulada" },
];

export const estadoMatriculaLabel = (value = "") => {
  const found = ESTADOS_MATRICULA.find((item) => item.value === value);
  return found ? found.label : (value || "Desconocido");
};
